enum MnDocType {
  Unknown = 0,
  MyNumberCard = 1,
  NotificationCard = 2,
  ResidenceCertificate = 3
}

export default MnDocType;
